import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { CommonService } from '../app.service';
import { MessageService } from "../common/message.service";
import { LOGON_INFO, USER_TYPE, COMP_TYPE } from '../app.constants';
import { CarService, CarLocation } from '../member-kanri/car.service';
import { NoticeService } from '../notice/notice.service';
import { MobileService } from '../mobile/mobile.service';
import $ from 'jquery';
import { CompanyService } from '../member-kanri/company.service';


@Component({
    templateUrl: './login.component.html',
    styleUrls:   ['./login.component.css'],
    providers: [NoticeService, CarService, MobileService, CompanyService]
 })
export class LoginComponent implements OnInit {
    
    id: string = '';
    password: string = '';

    id_remember: boolean;

    @ViewChild('el_id') private elementRef_id: ElementRef;
    @ViewChild('el_pwd') private elementRef_pwd: ElementRef;

    constructor (
        public router: Router,
        public authService: AuthService,
        public commonService: CommonService,
        public carService: CarService,
        public messageService: MessageService,
        public noticeService: NoticeService,
        public mobileService: MobileService,
        public companyService: CompanyService
    ) { }


    ngOnInit() {
        if (this.authService.isAuthenticated()) {
            this.pageRedirect();
        }
        else {
            this.id_remember = localStorage.getItem("cargo_share__login_id") ? true : false;
            if (this.id_remember) {
                this.id = localStorage.getItem("cargo_share__login_id");
            }
        }

        $(document).ready(function() {
            $("#show_hide_password a").on('click', function(event) {
                event.preventDefault();
                if($('#show_hide_password input').attr("type") == "text"){
                    $('#show_hide_password input').attr('type', 'password');
                    $('#show_hide_password i').addClass( "fa-eye-slash" );
                    $('#show_hide_password i').removeClass( "fa-eye" );
                }else if($('#show_hide_password input').attr("type") == "password"){
                    $('#show_hide_password input').attr('type', 'text');
                    $('#show_hide_password i').removeClass( "fa-eye-slash" );
                    $('#show_hide_password i').addClass( "fa-eye" );
                }
            });
        });
    }


    ngAfterViewInit(): void {
        if (this.id_remember) {
            this.elementRef_pwd.nativeElement.focus();
        } else {
            this.elementRef_id.nativeElement.focus();
        }
    }


    login() {
        this.authService.login(this.id, this.password)
        .subscribe(
            data => {
                if (!data) {
                    this.messageService.addError("ログインに失敗しました。(token unavailability)");
                    return;
                }

                this.messageService.clearAll();

                if (this.id_remember) {
                    localStorage.setItem("cargo_share__login_id", this.id);
                } else {
                    localStorage.removeItem("cargo_share__login_id");
                }

                let isTransUser = LOGON_INFO.USER_DIV == USER_TYPE.DRIVER || LOGON_INFO.USER_DIV == USER_TYPE.CLIENT ? false : true;

                //ドライバー会員の場合
                if (LOGON_INFO.USER_DIV == USER_TYPE.DRIVER) {
                    //担当車両が登録されている場合
                    if (LOGON_INFO.CAR_ID) {
                        let deviceLat_before = 0;
                        let deviceLng_before = 0;

                        let carLocation = new CarLocation();
                        carLocation.car_id = LOGON_INFO.CAR_ID;

                        //10分間隔で端末GPS情報を送信する
                        let gps_send_interval = setInterval(() => {
                            this.mobileService.getDeviceCurrentLocation()
                            .then(
                                (data) => {
                                    if (deviceLat_before != data[2] || deviceLng_before != data[3]) {
                                        carLocation.lat = data[0];
                                        carLocation.lng = data[1];
                                        this.carService.registCarLocation(carLocation).subscribe();
                                        deviceLat_before = data[2];
                                        deviceLng_before = data[3];
                                    }
                                }
                            )
                            .catch(
                                (error) => {
                                    clearInterval(gps_send_interval);
                                    this.messageService.addError("位置情報使用を許可してください。");
                                }
                            );
                        }, 1000*60*10);
                    }
                }
                //ドライバー会員ではない場合
                else {
                    this.commonService.getAllCode();

                    //祝日情報を取得
                    this.commonService.getHoliday();

                    //お知らせリストを取得
                    // this.noticeService.fetchNotice();

                    //運送会社会員の場合
                    if (isTransUser) {
                        //営業所リスト取得
                        this.companyService.fetchCompanyListForCombo();
                        //所属車両リストを取得
                        this.carService.fetchAllCarList();
                    }
                }
                
                this.commonService.getTodohuken();
                
                //0.1秒毎にコード取得完了か確認、取得済み時に画面遷移
                let temp = setInterval(() => {
                    if (sessionStorage.getItem('TODOHUKEN') && ((isTransUser && this.companyService.getCompanyListForCombo() && this.carService.getAllCarList() && this.carService.getDispatchTargetCarList()) || !isTransUser)) {
                        clearInterval(temp);
                        this.pageRedirect();
                    }
                }, 100);
            }
        );
    }

    moveToClientRegistPage() {
        this.router.navigate(["/client-regist"]);
    }

    moveToTransportRegistPage() {
        this.router.navigate(["/transport-regist"]);
    }

    pageRedirect() {
        let loginRedirect = '/notice-show';
        if (LOGON_INFO.USER_DIV == USER_TYPE.CLIENT) {
            loginRedirect = '/cargo/client';
        } else if (LOGON_INFO.USER_DIV == USER_TYPE.DRIVER) {
            loginRedirect = '/mobile/main';
        }

        let redirect = this.authService.redirectUrl ? this.authService.redirectUrl : loginRedirect;
        this.router.navigate([redirect]);
    }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts